import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://qazhweunmfzifeenbozk.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFhemh3ZXVubWZ6aWZlZW5ib3prIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY4NDQ5NTIsImV4cCI6MjA2MjQyMDk1Mn0.NtfKMkFahyJOxWcNCKxtZoIKtyaXjsxM92GaBdElC2A';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL or anon key is missing. Make sure to set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    // More aggressive session persistence for mobile apps
    detectSessionInUrl: true,
    flowType: 'implicit',
    // Storage key for session persistence
    storageKey: 'supabase.auth.token',
    // Debug mode disabled to reduce console noise
    debug: false
  },
  db: {
    schema: 'public'
  },
  // Global settings for better mobile app experience
  global: {
    headers: {
      'x-application-name': 'NoorCAD-mobile-app',
    },
    // Custom fetch with longer timeout for large payloads (e.g. 400+ photo surveys)
    fetch: (url, options = {}) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 120000); // 2 minute timeout
      
      return fetch(url, {
        ...options,
        signal: controller.signal,
      }).finally(() => {
        clearTimeout(timeoutId);
      });
    },
  },
  // Realtime settings (if using realtime features)
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Set up storage event listener for cross-tab session sync (web only)
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'supabase.auth.token' && e.newValue) {
      console.log('[Supabase] Session updated in another tab');
    }
  });
  
  // Note: Session persistence and refresh are handled by:
  // 1. Supabase SDK (persistSession: true, autoRefreshToken: true)
  // 2. useAppLifecycle hook (foreground refresh, periodic timer)
  // No additional handlers needed here to avoid duplication
} 